'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { AlertTriangle, RotateCw, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, [error]);

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-surface-light px-6">
      <div className="text-center max-w-lg">
        <div className="inline-flex h-16 w-16 rounded-2xl bg-error/10 items-center justify-center mb-6 ring-8 ring-error/5">
          <AlertTriangle className="h-7 w-7 text-error" aria-hidden />
        </div>
        <span className="eyebrow text-accent mb-3 inline-block">Erreur</span>
        <h1 className="font-display text-h2 text-ink leading-tight">
          Quelque chose s&apos;est mal passé.
        </h1>
        <p className="mt-4 text-base text-ink-secondary leading-relaxed">
          Une erreur inattendue est survenue. Notre équipe a été notifiée. Vous
          pouvez réessayer ou retourner à l&apos;accueil.
        </p>
        {error?.digest && (
          <p className="mt-3 text-xs text-ink-muted">
            Référence&nbsp;: <code className="font-mono">{error.digest}</code>
          </p>
        )}

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Button variant="navy" onClick={reset} className="gap-2">
            <RotateCw className="h-4 w-4" />
            Réessayer
          </Button>
          <Button asChild variant="outline" className="gap-2">
            <Link href="/">
              <Home className="h-4 w-4" />
              Retour à l&apos;accueil
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
